import { WorkflowsRoutePath } from "#src/routes/workflows";
import { RoutePath } from "#src/utils/route";

export const WorkflowsAllRoutePath = WorkflowsRoutePath.concat(
  new RoutePath<string, "tab">({
    path: "/all",
    title: "All Workflows",
  })
);
